export function AbilityActivated({
	icon,
	background = `/liveGameIcons/tech_background.png`,
}) {
	return (
		<div
			className="w-10 h-10 border-solid abilityGlow"
			style={{
				backgroundImage: `url(${background})`,
				borderColor: 'var(--main-color)',
			}}
		>
			<img src={icon} alt="" />
		</div>
	)
}
